module.exports = __webpack_public_path__ + "img/about1.f66bf889.jpg";